const key = 'LICHENG_TIMECATCH'

export default {
  get() {
    return JSON.parse(window.localStorage.getItem(key)) || []
  },
  set(value = '') {
    if (!value) return
    localStorage.setItem(key, JSON.stringify([...this.get(), value]))
  },
  clear() {
    localStorage.removeItem(key)
  },
}
